import classNames from 'classnames';
import { Button, FlexContainer, Txt } from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { leaveAReviewUrl } from 'config';
import { useDataActions, useTenancy } from 'state';
import styles from './TodoItemPropertyOccupied.module.scss';

/**
 * TodoItemPropertyOccupied
 *
 * @return {JSX.Element}
 */
const TodoItemPropertyOccupied = ({ className }) => {
  const [isLoading, setIsLoading] = useState(false);
  const storageAction = useDataActions();
  const tenancyDoc = useTenancy();
  // const {
  //   state: { state: tenancyData },
  //   tenantsState: { state: tenantsData },
  // } = tenancyViewState;
  const handleMarkAsOccupied = () => {
    console.log('.........handleMarkAsOccupied..........');
    setIsLoading(true);
    storageAction.tenancy
      .markAsOccupied(tenancyDoc)
      .finally(() => setIsLoading(false));
  };

  const isDone = tenancyDoc.propertyIsOccupied;

  return (
    <FlexContainer
      className={classNames(
        styles.TodoItemPropertyOccupied,
        className,
        TodoItemPropertyOccupied.displayName
      )}
      column
      gap
    >
      {isDone ? (
        <>
          <Txt bold>Property is occupied 🏡 🎉</Txt>
          <Txt regular>
            Congratulations on a fully compliant tenancy! Welcome to the future
            of renting, we’re very grateful to have you onboard.
          </Txt>
          <Txt regular>
            If you've enjoyed using Propa please take a minute to leave a review
            on TrustPilot using the button below.
          </Txt>
          <a
            href={leaveAReviewUrl}
            target="_blank"
            className={styles.ButtonLink}
            rel="noreferrer"
          >
            <Button success flex>
              Leave a Review
            </Button>
          </a>
        </>
      ) : (
        <>
          <Txt bold>🏡❓ Property is not occupied</Txt>
          <Txt regular>
            When the tenancy has started and the property is occupied tap the
            button below to mark this property as occupied.
          </Txt>
          <Button success onClick={handleMarkAsOccupied} disabled={isLoading}>
            Mark Property as Occupied
          </Button>
        </>
      )}
    </FlexContainer>
  );
};

TodoItemPropertyOccupied.displayName = 'TodoItemPropertyOccupied';

export default observer(TodoItemPropertyOccupied);
